import counterpart from 'counterpart';
import { initCommonTranslate } from 'Utils/languages';
import { VITE_REPORTS_KEY, VITE_ACCOUNT_MANAGEMENT_KEY, VITE_INTERNAL_ADMIN_KEY } from 'Constants/appEnvConstants';

export function navItems() {
  initCommonTranslate();

  const translatedNavItems = [
    {
      title: counterpart('globalTranslate.navigation.dashboard'),
      key: null,
      slug: 'dashboard',
      children: [],
    },
    {
      title: counterpart('globalTranslate.navigation.reports'),
      key: VITE_REPORTS_KEY,
      slug: 'reports',
      children: [],
     /*  children: [
        {
          path: '/reports',
          title: counterpart('globalTranslate.reports.defaultReports'),
          id: 1,
          forceIsActiveOnQueryString: 'tab=default',
        },
        {
          path: '/reports?tab=custom',
          title: counterpart('globalTranslate.reports.customReports'),
          id: 2,
          forceIsActiveOnQueryString: 'tab=custom',
        },
        {
          path: '/reports?tab=generated',
          title: counterpart('globalTranslate.reports.generatedReports'),
          id: 3,
          forceIsActiveOnQueryString: 'tab=generated',
        },
      ], */
    },
    {
      title: counterpart('globalTranslate.navigation.transactions'),
      key: null,
      slug: 'transaction-finder',
      children: [],
    },
    {
      title: counterpart('globalTranslate.navigation.messageCenter'),
      hideSubNavOnFlag: 'isQa2orCert',
      key: null,
      slug: 'messages',
      children: [],
    },
    {
      title: counterpart('globalTranslate.navigation.accountManagement'),
      key: VITE_ACCOUNT_MANAGEMENT_KEY,
      slug: 'account-management',
      children: [
        {
          path: '/account-management/chain-statements',
          title: counterpart('globalTranslate.navigation.chainStatements'),
          id: 1,
        },
        {
          path: '/account-management/statements',
          title: counterpart('globalTranslate.navigation.statements'),
          id: 2,
        },
        {
          path: '/account-management/user-management',
          title: counterpart('globalTranslate.navigation.users'),
          id: 3,
        },
        {
          path: '/account-management/documents',
          title: counterpart('globalTranslate.navigation.documents'),
          id: 4,
        },
        {
          path: '/account-management/locations',
          title: counterpart('globalTranslate.navigation.locations'),
          id: 5,
        },
        {
          path: '/account-management/equipment',
          title: counterpart('globalTranslate.navigation.equipment'),
          id: 6,
        },
        {
          path: '/account-management/managelocations',
          title: counterpart('globalTranslate.navigation.locations'),
          id: 7,
        },
        {
          path: '/account-management/product-offering',
          title: counterpart('globalTranslate.navigation.productOffering'),
          id: 8,
        },
      ],
    },
    {
      title: counterpart('globalTranslate.navigation.internalAdmin'),
      hideSubNavOnFlag: 'isQa2orCert',
      key: VITE_INTERNAL_ADMIN_KEY,
      slug: 'internal-admin',
      children: [
        {
          path: '/internal-admin/manage-products',
          title: counterpart('globalTranslate.navigation.manageProducts'),
          id: 1,
        },
        {
          path: '/internal-admin/release-statements',
          title: counterpart('globalTranslate.navigation.releaseStatements'),
          id: 2,
        },
      ],
    },
  ];

  return translatedNavItems;
}

export default navItems;
